function readCookie(name) {
  if (typeof document === 'undefined' || typeof document.cookie !== 'string') return null;

  const prefix = `${name}=`;
  const match = document.cookie
    .split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(prefix));

  if (!match) return null;

  const value = decodeURIComponent(match.slice(prefix.length)).trim();
  return value.length > 0 ? value : null;
}

function queryParams() {
  if (typeof window === 'undefined' || !window.location) return {};

  const params = {};
  const search = new URLSearchParams(window.location.search || '');

  for (const [key, value] of search.entries()) {
    if (typeof value === 'string' && value.trim().length > 0) {
      params[key] = value.trim();
    }
  }

  return params;
}

function browserTimezone() {
  try {
    if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') return null;

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof timezone === 'string' && timezone.trim().length > 0 ? timezone.trim() : null;
  } catch (_error) {
    return null;
  }
}

export default {
  FirstImpression: {
    mounted() {
      this.pushEvent('capture_first_impression', {
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent || null : null,
        fbp: readCookie('_fbp'),
        fbc: readCookie('_fbc'),
        timezone: browserTimezone(),
        query: queryParams(),
      });
    },
  },
};
